import { LoginForm } from '@/components/auth/LoginForm';
import { Button } from '@/components/ui/button';
import { Hand, Home, Languages } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { VolunteerScopeNotice } from '@/components/auth/VolunteerScopeNotice';

export function LoginPage() {
  const navigate = useNavigate();
  const { t, language, setLanguage, dir } = useLanguage();
  
  const isFromVolunteerRoute = sessionStorage.getItem('redirectAfterLogin') === '/vol';

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ar' : 'en');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-secondary/30 px-4 py-8 relative" dir={dir}>
      {/* Top bar: Home + Language */}
      <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
        <button
          onClick={() => navigate('/landing')}
          className="text-muted-foreground hover:text-foreground transition-colors px-3 py-2 rounded-lg hover:bg-white/60 flex items-center gap-1.5 text-sm font-medium"
        >
          <Home className="h-4 w-4" />
          {t('auth.backToHomepage') || 'العودة للرئيسية'}
        </button>
        <button
          onClick={toggleLanguage}
          className="text-muted-foreground hover:text-foreground transition-colors px-3 py-2 rounded-lg hover:bg-white/60 flex items-center gap-1.5 text-sm font-medium"
        >
          <Languages className="h-4 w-4" />
          {language === 'en' ? 'العربية' : 'English'}
        </button>
      </div>

      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center gap-2">
          <img 
            src="/namatplatformlogo.png"
            alt="Namat Platform"
            className="h-auto w-[250px] object-contain" 
          />
        </div>
        {/* #72: arriving from /vol — make clear this is not beneficiary sign-up */}
        {isFromVolunteerRoute && <VolunteerScopeNotice />}
        <LoginForm />
        
        {!isFromVolunteerRoute && (
          <div className="w-full">
            <Button
              onClick={() => navigate('/vol')}
              className="w-full bg-[#004250] hover:bg-[#003340] text-white font-semibold py-6 text-base shadow-lg transition-all hover:shadow-xl flex items-center justify-center gap-2"
              size="lg"
            >
              <Hand className="h-5 w-5" />
              {t('auth.volunteerWithUs') || 'تطوع معنا'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}